// CORE-1735 slice 17 (D-120, QA V06) — Live icon «people» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Circle, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const People: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Circle cx={9} cy={7} r={4} fill={color} />
    <Path d="M1 22v-2a8 8 0 0 1 16 0v2Z" fill={color} />
    <Circle cx={19} cy={8} r={3} fill={color} />
    <Path d="M18 14a6 6 0 0 1 6 6v2h-5v-2a10 10 0 0 0-2-6Z" fill={color} />
    </G>
  </Svg>
);
